import React, { useCallback, useMemo, useRef, useState } from 'react';
import { useScommessaStatus } from 'features/sport/hooks';
import { domContains } from 'utility/functions';
import { useIsomorphicLayoutEffect } from 'hooks';
import { EVENTS_DELAY, ScommesseFallbackHookProps, ScommesseFallbackHookType } from 'components/scommessaFallback';
import { isClientSide } from 'utility/constant';

import styles from './ScommesseFallback.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import { selectCurrentPath } from 'features/sport';
import { selectIsLoading } from 'features/location/selectors';

export const useScommesseFallback = ({ container, isReady }: ScommesseFallbackHookProps): ScommesseFallbackHookType => {
  const tmrRef = useRef<NodeJS.Timeout | undefined>();

  const { isLoading, isError, isUninitialized } = useScommessaStatus();
  const isPending = useTypedSelector(selectIsLoading);
  const currentPath = useTypedSelector(selectCurrentPath);

  const [isEmpty, setEmpty] = useState(true);

  const doCount = useCallback(() => {
    if (!container || isPending) {
      setEmpty(false);
    } else if (isReady) {
      let haBet = domContains(container, ["[data-kind='betting-option']", "[class*='ScommesseAccordion_item']"]);
      setEmpty(haBet ? false : true);
    }
  }, [container, isReady, isPending]);

  useIsomorphicLayoutEffect(() => {
    if (tmrRef.current) {
      clearInterval(tmrRef.current);
    }
    tmrRef.current = setInterval(doCount, EVENTS_DELAY);
  }, [isPending, isReady, container, doCount]);

  useIsomorphicLayoutEffect(() => {
    if (!container) {
      return;
    }

    if (isPending && !container.classList.contains(styles.containerOff)) {
      container.classList.add(styles.containerOff);
    } else if (!isPending && container.classList.contains(styles.containerOff)) {
      container.classList.remove(styles.containerOff);
    }
  }, [container, isPending]);

  return useMemo((): ScommesseFallbackHookType => {
    let showEmpty = false;
    let showLoader = false;

    if (isReady) {
      if (isClientSide && decodeURI(document.location.pathname) !== currentPath) {
        showLoader = true;
      } else {
        showLoader = isPending ? true : isEmpty && (isLoading || isUninitialized);
      }

      showEmpty = showLoader ? false : isError || isEmpty;
    }

    // console.log('useScommesseFallback(', currentPath, isClientSide ? decodeURI(document.location.pathname) : currentPath, `isEmpty:${isEmpty}`,`isPending:${isPending}`,`isLoading:${isLoading}`,`isUninitialized:${isUninitialized}) => `,`showLoader:${showLoader}`,`showEmpty:${showEmpty}`);

    return {
      showEmpty,
      showLoader,
    };
  }, [isEmpty, isReady, isError, isPending, isLoading, isUninitialized, currentPath]);
};
